import Swiper from 'Swiper';
import UiHelper from './UiHelper';

const selectors = {
    wrap: '.js-logos-block',
    slider: '.js-logos-block__slider',
    prev: '.js-logos-block__prev',
    next: '.js-logos-block__next'
}

class LogoSliderFactory
{
    static init()
    {
        Array.from(UiHelper.getNodes(selectors.wrap)).forEach(wrap =>
        {
            if (wrap.querySelectorAll('.swiper-slide').length > 4)
            {
                new LogoSlider(wrap);
            }
            else
            {
                wrap.classList.add('logos-block--no-slider')
            }
        });
    }
}
export default LogoSliderFactory;

class LogoSlider
{
    constructor(wrap)
    {
        this.swiper = new Swiper(wrap.querySelector(selectors.slider), {
            slidesPerView: 5,
            loop: true,
            breakpoints: {
                575: { slidesPerView: 2 }, // <= 575px (xs)
                767: { slidesPerView: 3 }, // <= 767px (sm)
                991: { slidesPerView: 4 }  // <= 991px (md)
            }
        });

        this.prev = wrap.querySelector(selectors.prev);
        this.next = wrap.querySelector(selectors.next);

        this.prev.addEventListener('click', e => { this.swiper.slidePrev(); });
        this.next.addEventListener('click', e => { this.swiper.slideNext(); });
    }
}
